import { SubmitButton } from "../../components/shared/buttons/submit-button";
import Card from "../../components/shared/card";
import Typography from "../../components/shared/typography";
import { formatPhoneNumberToHumanReadable } from "../../components/utls/utils";
import { useMedicalRecordRequestDetailContext } from "../context/MedicalRecordRequestDetailContext";

export function RecipientDetailsCard() {
  const {
    recipientDetails,
    isEditable,
    canLookupFax,
    handleLookupFax,
    isLookupLoading,
  } = useMedicalRecordRequestDetailContext();
  if (!recipientDetails) {
    return null;
  }

  return (
    <Card variant="cream" elevation={1}>
      <Card.Header>
        <div className="flex items-center justify-between gap-2">
          <Typography variant="h4" className="text-terracotta">
            Recipient Details
          </Typography>
          {isEditable && canLookupFax && (
            <SubmitButton
              size="sm"
              color="beige"
              onClick={handleLookupFax}
              isLoading={isLookupLoading}
            >
              Lookup Fax
            </SubmitButton>
          )}
        </div>
      </Card.Header>
      <Card.Body className="space-y-3">
        {isLookupLoading && (
          <Typography variant="caption" className="text-brown-600">
            Looking up fax… We’ll refresh this request every few seconds.
          </Typography>
        )}
        <div className="space-y-1">
          {recipientDetails.name && (
            <Typography variant="body2" className="text-terracotta/80">
              {recipientDetails.name}
            </Typography>
          )}
          {recipientDetails.type && (
            <Typography variant="body2" className="text-terracotta/70">
              Type: {recipientDetails.type}
            </Typography>
          )}
          {recipientDetails.phone && (
            <Typography variant="body2" className="text-terracotta/70">
              Phone: {formatPhoneNumberToHumanReadable(recipientDetails.phone)}
            </Typography>
          )}
          {recipientDetails.email && (
            <Typography variant="body2" className="text-terracotta/70">
              Email: {recipientDetails.email}
            </Typography>
          )}
          {recipientDetails.address && (
            <Typography variant="body2" className="text-terracotta/70">
              Address: {recipientDetails.address}
            </Typography>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default RecipientDetailsCard;
